import React from 'react';
import { Container, Section } from '../components/ui/Section';
import { ButtonLink } from '../components/ui/Button';
export function NotFound() {
  return <Section className="bcm-paper py-20 sm:py-28" data-id="element-591" data-mp="w6dohvu55851">
      <Container className="max-w-2xl" data-id="element-592" data-mp="105la7jf48ucy">
        <p className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-navy" data-id="element-593" data-mp="107z77xtcwgn5">
          Page not found
        </p>
        <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-brand-navy sm:text-5xl" data-id="element-594" data-mp="1a4anszzzbsne">
          This page moved, but you’re still welcome.
        </h1>
        <p className="mt-5 font-sans text-[17px] leading-relaxed text-ink" data-id="element-595" data-mp="1f0sn3kcjiysc">
          BCM meets Thursdays at 7:30 PM. Start on the homepage or check what is coming up next.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-596" data-mp="1nxjq6gpifdwf">
          <ButtonLink to="/" data-id="element-597" data-mp="1svl8v0j0xb7d">Back to Home</ButtonLink>
          <ButtonLink to="/events" variant="secondary" data-id="element-598" data-mp="1xtmsbmkd3cjd">
            See Events
          </ButtonLink>
        </div>
      </Container>
    </Section>;
}